import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { AwsApiService } from './aws-api.service';
import { Credentials } from '../types/credentials';
import { RouterService } from './router.service';
import { SessionService } from './session.service';
import { Challenge } from '../types/challenge';
import { Workflow } from '../types/workflow';
import { IWorkflow } from '../interfaces/IWorkflow';
import { SpinnerService } from './spinner.service';
import { environment } from '../../environments/environment';
import { SessionStorageService } from './session-storage.service';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { ToasterService } from './toaster.service';
import { PasswordService } from './password.service';
import { NetPromoterScoreComponent } from '../components/npscore/net-promoter-score.component';
import { ModalService } from './modal.service';
import { PrivacyNoticeComponent } from 'app/components/privacy/user-privacy-notice.component';
import { AdminService } from '../services/admin.service';
import { AuditService } from './audit.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoginService implements IWorkflow {
  private challenge: Challenge;
  private credentials: Credentials;
  private workflow: Workflow;
  private rememberDeviceFlag: boolean;

  constructor(
    private admin: AdminService,
    private api: AwsApiService,
    private http: HttpClient,
    private log: LogService,
    private router: RouterService,
    private spinner: SpinnerService,
    private auditService: AuditService,
    private sessionStorage: SessionStorageService,
    private toastService: ToasterService,
    private passwordService: PasswordService,
    private localStorage: LocalStorageService,
    private modalService: ModalService
  ) {
    this.workflow = new Workflow('Login', log);
  }

  getChallenge(): Challenge {
    return this.challenge;
  }

  setRememberDeviceFlag(rememberDeviceFlag: boolean) {
    this.rememberDeviceFlag = rememberDeviceFlag;
  }

  isInProgress(): boolean {
    return this.workflow.isInProgress();
  }

  reset() {
    this.workflow.end();
    this.credentials = null;
    this.challenge = null;
  }

  getUsername() {
    return this.credentials.username;
  }

  openPrivacyNotice() {
    var mxUsername=this.sessionStorage.getUser().username;
    this.log.trace('openPrivacyNotice.mxUsername', mxUsername);
    this.auditService.auditEvent(
      mxUsername,
      'UUX Privacy Notice' ,
      'Privacy notice windows is dispalyed to user upon login to UUX',
      'UUXPrivacyNotice'
     );
    this.modalService.open(PrivacyNoticeComponent);
  }
  openUserExprienceScore() {
    this.modalService.open(NetPromoterScoreComponent);
  }
  initiateAuth(credentials: Credentials, onErrorCallback: Function) {
    this.log.trace('LoginService.initiateAuth', credentials.username);
    //console.log('initiateAuth-credentials: ' + ' -> ' + JSON.stringify(credentials));

    this.credentials = credentials;
    this.sessionStorage.setUserName(credentials.username);
    this.workflow.start();

    this.spinner.showSpinner();

    const onSuccess = data => {
      this.log.trace('loginService.initiateAuth.onSuccess', data);
      this.spinner.hideSpinner();

      // call to initiateAuth must come back with Organization
      if (data.Organization) {
        this.sessionStorage.setOrganization(data.Organization);
      } else {
        this.log.error('no organization found in initiateAuth response', data);
      }
      // allow the server to set the UUX session ID
      if (data.UUXSessionId) {
        this.log.trace('loginService.initiateAuth.onSuccess->data.UUXSessionId', data.UUXSessionId);
        this.sessionStorage.setUUXSessionId(data.UUXSessionId);
      }
      if ( (data.ChallengeName) && (( data.ChallengeName != 'NPS_EXPIRED') && ( data.ChallengeName != 'PNOTICE_EXPIRED'))) {
        this.log.trace('nps challenge name-> ' + data.ChallengeName);
        this.handleChallenge(data);
      }else {
        this.log.trace('loginSuccess-> ' + data.ChallengeName);
        this.loginSuccess(data);
        if ( (data.ChallengeName ) && (data.ChallengeName =='PNOTICE_EXPIRED')) {
          this.log.trace('Privacy notice challenge-> ' + data.ChallengeName);
          this.openPrivacyNotice();
        }
        else if ( (data.ChallengeName ) && (data.ChallengeName =='NPS_EXPIRED')) {
          this.log.trace('User experience challenge-> ' + data.ChallengeName);
          this.openUserExprienceScore();
        }
      }
    };

    const onError = err => {
      this.log.error('loginService.initiateAuth.onError', err);
      this.spinner.hideSpinner();
      this.reset();

      if (err.code === 'PasswordResetRequiredException') {
        this.router.gotoForgotPassword();
      } else {
        onErrorCallback(err);
      }
    };

    const hsApi = environment.api.initiateAuth;
    const params = {
      username: this.credentials.username,
      password: this.credentials.password,
      deviceKey:
        this.sessionStorage.getDeviceKey(this.credentials.username) || undefined
    };
    this.http.post(hsApi, params).subscribe(onSuccess, onError);
  }

  //Added directAuth workflow
  directAuth(authCode: string, clientId: string, onErrorCallback: Function) {
    this.log.trace('LoginService.directAuth', { authCode, clientId });
  
    this.workflow.start();
    this.spinner.showSpinner();
  
    const onSuccess = data => {
      this.log.trace('loginService.directAuth.onSuccess', data);
      this.spinner.hideSpinner();
  
      // Allow the server to set the UUX session ID
      if (data.UUXSessionId) {
        this.log.trace('loginService.directAuth.onSuccess->data.UUXSessionId', data.UUXSessionId);
        this.sessionStorage.setUUXSessionId(data.UUXSessionId);
      }
  
      if (data.Organization) {
        this.sessionStorage.setOrganization(data.Organization);
      } else {
        this.log.error('No organization found in directAuth response', data);
      }
  
      if ((data.ChallengeName) && (data.ChallengeName != 'NPS_EXPIRED') && (data.ChallengeName != 'PNOTICE_EXPIRED')) {
        this.log.trace('nps challenge name-> ' + data.ChallengeName);
        this.handleChallenge(data);
      } else {
        this.log.trace('loginSuccess-> ' + data.ChallengeName);
        this.loginSuccess(data);
        if ((data.ChallengeName) && (data.ChallengeName == 'PNOTICE_EXPIRED')) {
          this.log.trace('Privacy notice challenge-> ' + data.ChallengeName);
          this.openPrivacyNotice();
        } else if ((data.ChallengeName) && (data.ChallengeName == 'NPS_EXPIRED')) {
          this.log.trace('User experience challenge-> ' + data.ChallengeName);
          this.openUserExprienceScore();
        }
      }
    };
  
    const onError = err => {
      this.log.error('loginService.directAuth.onError', err);
      this.spinner.hideSpinner();
      this.reset();
  
      onErrorCallback('Unable to login to MX User Portal. Please try again.');
    };
  
    const hsApi = environment.api.directAuth;
    const params = {
      code: authCode,
      clientId: clientId
    };
  
    this.http.post(hsApi, params).subscribe(onSuccess, onError);
  }
  

  private loginSuccess(result) {
    this.log.trace('login success', result);

    // store authentication result in session storage
    this.sessionStorage.setAuthenticationResult(result.AuthenticationResult);

    // store custom logout url
    if (result.LogoutUrl) {
      this.sessionStorage.setLogoutURL(result.LogoutUrl);
    } 
    

    if (result.Message) {
      this.toastService.showInfo(result.Message);
    }

    // Only remember device after MFA challenges
    if (
      result.AuthenticationResult.NewDeviceMetadata &&
      this.workflow.hasMFAChallenge
    ) {
      this.spinner.showSpinner();

      // only store device key long-term if user opts-in
      if (this.rememberDeviceFlag) {
        this.localStorage.setDeviceKey(
          this.sessionStorage.getUser().username,
          result.AuthenticationResult.NewDeviceMetadata.DeviceKey
        );
      }
      // otherwise keep it in session storage so it can be used during a refresh
      else {
        this.sessionStorage.setTemporaryDeviceKey(
          result.AuthenticationResult.NewDeviceMetadata.DeviceKey
        );
      }

      this.confirmDevice(
        result.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey,
        result.AuthenticationResult.NewDeviceMetadata.DeviceKey
      );
    } else {
      this.totalSuccess();
    }
  }

  // should be executed when no more steps are needed
  private totalSuccess() {
    // clear workflow info
    this.reset();
    // nagivate to homepage
    this.spinner.hideSpinner();
    this.router.gotoHome();
  }

  private rememberDevice(deviceKey) {
    this.log.trace('rememberDevice', deviceKey);
    this.http
      .post(environment.api.rememberDevice, {
        accessToken: this.sessionStorage.getAccessToken(),
        deviceKey: deviceKey
      })
      .subscribe(data => {
        this.totalSuccess();
      });
  }

  private confirmDevice(groupKey: string, deviceKey: string) {
    this.log.trace('loginService.confirmDevice', {
      groupKey: groupKey,
      deviceKey: deviceKey
    });

    const onSuccess = data => {
      this.log.trace('loginService.confirmDevice.onSuccess', data);
      if (data.UserConfirmationNecessary) {
        this.rememberDevice(deviceKey);
      } else {
        this.totalSuccess();
      }
    };

    const onError = err => {
      this.log.error('loginService.confirmDevice.onError', err);
    };

    const hsApi = environment.api.confirmDevice;
    const organization = this.sessionStorage.getOrganization();
    const params = {
      accessToken: this.sessionStorage.getAccessToken(),
      deviceKey: deviceKey,
      deviceGroupKey: groupKey,
      deviceName: navigator.userAgent,
      username: this.credentials.username,
      password: this.credentials.password,
      userPoolId: this.sessionStorage.getOrganization().UserPoolId
    };
    // Create a shallow copy of params without the password
    const logParams = { ...params };
    delete logParams.password;

    this.log.trace('connecting', { hsApi: hsApi, params: logParams });

    //this.log.trace('connecting', { hsApi: hsApi, params: params });
    this.http.post(hsApi, params).subscribe(onSuccess, onError);
  }

  private handleChallenge(data: any) {
    this.challenge = new Challenge(data.ChallengeName, data.Session);
    this.log.trace('challenge encountered', this.challenge);

    if (this.challenge.isNewPasswordRequired()) {
      this.router.gotoLogin_NewPasswordRequired();
    } else if (this.challenge.isSMS_MFA()) {
      this.workflow.hasMFAChallenge = true;
      this.router.gotoLogin_ConfirmCodeSMS();
    } else if (this.challenge.isTOTP_MFA()) {
      this.workflow.hasMFAChallenge = true;
      this.router.gotoLogin_ConfirmCodeTOTP();
    } else if (this.challenge.isMfaSelfRegistration()) {
      this.router.gotoLogin_MfaSelfRegistration();
    } else if (this.challenge.isPasswordExpired()) {
      // Expired password is a custom challenge workflow, so the response has
      // the user's authentication tokens
      delete data.ChallengeName;
      this.workflow.authenticatedResponse = data;
      this.router.gotoLogin_PasswordExpired();
    } else {
      this.log.warn('challenge not implemented -> ' + this.challenge.name);
    }
  }

  public respondToExpiredPasswordChallenge(
    newPassword: string,
    onErrorCallback: Function
  ) {
    return this.passwordService.changePassword(
      this.credentials.password, // old password
      newPassword, // entered password
      (err, data) => {
        if (err) {
          return onErrorCallback(err);
        } else {
          return this.loginSuccess(this.workflow.authenticatedResponse);
        }
      },
      this.workflow.authenticatedResponse.AuthenticationResult.AccessToken
    );
  }

  public respondToSelfMfaChallenge(phone: string, onErrorCallback: Function) {
    this.spinner.showSpinner();

    const hsApi = environment.api.setMfaPhone;

    const params = {
      uuxSessionId: this.sessionStorage.getUUXSessionId(),
      phone: phone
    };

    const onSuccess = data => {
      return this.initiateAuth(this.credentials, onErrorCallback);
    };

    const onError = err => {
      this.spinner.hideSpinner();
      this.log.error('respondToAuthChallenge.onError', err);
      onErrorCallback(err);
    };

    return this.http.post(hsApi, params).subscribe(onSuccess, onError);
  }

  public respondToAuthChallenge(extraParams: any, onErrorCallback: Function) {
    this.log.trace('responding to challenge', this.challenge);
    const organization = this.sessionStorage.getOrganization();

    const params = {
      challengeName: this.challenge.name,
      clientId: organization.ClientId,
      userPoolId: organization.UserPoolId,
      session: this.challenge.session,
      username: this.credentials.username,
      newPassword: extraParams.newPassword,
      code: '_' + (extraParams.code ? extraParams.code : '')
    };
    if (extraParams.newPassword){
      this.workflow.hasNewPasswordChallenge = true;
      this.credentials.password = extraParams.newPassword;
    }
    this.spinner.showSpinner();
    const hsApi = environment.api.respondToAuthChallenge;

    const onSuccess = data => {
      this.spinner.hideSpinner();

      // allow the server to set the UUX session ID
      if (data.UUXSessionId) {
        this.sessionStorage.setUUXSessionId(data.UUXSessionId);
      }
      if ( data.ChallengeName) {
        this.handleChallenge(data);
      } else {
        this.loginSuccess(data);
        this.log.trace('respondToAuthChallenge Privacy notice start-> ' + data.ChallengeName);
        if (this.workflow.hasNewPasswordChallenge){
          this.openPrivacyNotice();
        }
      }
    };

    const onError = err => {
      this.spinner.hideSpinner();
      this.log.error('respondToAuthChallenge.onError', err);
      onErrorCallback(err);
    };

    this.http.post(hsApi, params).subscribe(onSuccess, onError);
  }
}
